export default class Device {
  id = ''
  alias = ''
  bindUserId = ''
  isBinded = ''
  inUsingUserId = ''
  inUsingUserInfo = ''
  isInUsing = ''
  isPublic = ''
  isShared = ''
  usingOn = ''
  offUsingOn = ''
  connectNetworkTime = ''
  isConnectedTutk = ''
  type = ''
  usingMsg = ''
  needUpdateFw = ''

  loadData = function (jsonData, selfId) {
    this.id = jsonData.id
    this.alias = jsonData.alias
    this.bindUserId = jsonData.bindUserId
    this.isBinded = jsonData.isBinded
    this.inUsingUserId = jsonData.inUsingUserId
    this.inUsingUserInfo = jsonData.inUsingUserInfo
    this.isInUsing = jsonData.isInUsing
    this.isPublic = jsonData.isPublic
    this.isShared = jsonData.isShared
    this.usingOn = jsonData.usingOn
    this.offUsingOn = jsonData.offUsingOn
    this.connectNetworkTime = jsonData.connectNetworkTime
    this.isConnectedTutk = jsonData.isConnectedTutk
    this.type = jsonData.type
    this.needUpdateFw = jsonData.needUpdateFw
    // if (this.isInUsing) {
    //   this.usingMsg = VueI18n.$t('device.usedByOthers')
    //   if (this.inUsingUserId === Number(selfId)) {
    //     this.usingMsg = '您在使用'
    //   }
    // } else {
    //   this.usingMsg = '使用'
    // }
  }
}



// WEBPACK FOOTER //
// ./src/common/model/Device.js